// Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

type NavbarIconButtonType = {
  dataTestId: string;
  title: string;
  onClick: (_: React.MouseEvent<HTMLButtonElement>) => void;
  isUnderlined: boolean;
  icon: JSX.Element;
  // When true, the desktop button drops its visible text label and shows
  // just the icon (matching the mobile display, which is always icon-only)
  // -- `title` still becomes the native tooltip/aria-label.
  iconOnly?: boolean;
};

const NavbarIconButton = ({
  dataTestId,
  title,
  onClick,
  isUnderlined,
  icon,
  iconOnly = false,
}: NavbarIconButtonType) => {
  return (
    <>
      {/* Mobile button display */}
      <Button
        data-testid={`mobile-${dataTestId}`}
        key={`navbar-icon-button-${title}`}
        onClick={onClick}
        title={title}
        aria-label={title}
        sx={{
          display: { xs: "flex", md: "none" },
          position: "relative",
          alignContent: "center",
          minWidth: "fit-content",
          color: "#FFF",
          fontSize: 20,
        }}
      >
        {icon}
      </Button>

      {/* Desktop button display  */}
      <Button
        data-testid={`desktop-${dataTestId}`}
        key={title}
        onClick={onClick}
        title={iconOnly ? title : undefined}
        aria-label={iconOnly ? title : undefined}
        sx={{
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          color: "#FFF",
        }}
      >
        <Box
          sx={{
            marginRight: iconOnly ? 0 : "8px",
            fontSize: 20,
            display: "flex",
          }}
        >
          {icon}
        </Box>
        {!iconOnly && (
          <Box
            sx={{
              textTransform: "capitalize",
              fontSize: "16px",
              whiteSpace: "nowrap",
              width: "fit-content",
              borderBottom: "2px solid transparent",

              ...(isUnderlined && {
                fontWeight: "bold",
                borderBottom: "2px solid #E2772E",
                borderRadius: 0,
              }),
            }}
          >
            {title}
          </Box>
        )}
      </Button>
    </>
  );
};

export default NavbarIconButton;
